import { memo } from 'react';

const equal = (prev, next) => prev.selected.formType === next.selected.formType;

const MapComponent = ({ selected, mapper, formKey }) => mapper.forms[formKey][selected.formType];

export default memo(MapComponent, equal);
